<template>
    <div class="box p-15">
        <div class="columns is-mobile">
            <div class="column is-4">
                <a class="image campaign-image is-4by3" @click="$root.showCampaign(campaign.id)">
                    <img v-if="campaign.image" :src="campaign.image" :alt="campaign.brand.name" />
                </a>
            </div>
            <div class="column is-8">
                <div class="title is-5 campaign-title">
                    {{ campaign.title }}
                </div>

                <div v-if="campaign.short_description" class="text-14 mtb-5 text-light break-new-line">
                    {{ campaign.short_description }}
                </div>

                <div class="mtb-10">
                    <span v-if="accepted_proposals.length > 0" class="text-14">
                        You have {{ accepted_proposals.length }} accepted proposal<span v-if="proposals.length !== 1"
                            >s</span
                        >.
                    </span>
                    <span v-else-if="proposals.length > 0" class="text-14">
                        You have submitted {{ proposals.length }} proposal<span v-if="proposals.length !== 1">s</span>.
                    </span>
                </div>

                <div class="mt-5">
                    <div v-if="!recurring_proposals">
                        <button
                            v-if="!proposals.length"
                            class="button"
                            @click="$root.showCampaignApplication(campaign)"
                        >
                            <span>{{ customizationText('get_started_button_text', 'Get Started', campaign) }}</span>
                        </button>
                        <div v-else>
                            <router-link
                                v-if="
                                    accepted_proposals.length &&
                                    campaign.hasOwnProperty('version') &&
                                    campaign.version === 2
                                "
                                :to="{
                                    name: 'v2.campaign.proposal',
                                    params: { campaign_id: campaign.id, proposal_id: accepted_proposals[0].id }
                                }"
                                class="no-underline"
                            >
                                <button class="button">View</button>
                            </router-link>
                            <button
                                v-else-if="accepted_proposals.length"
                                class="button"
                                @click="$root.showJob(accepted_proposals[0].id)"
                            >
                                View
                            </button>
                            <button v-else class="button" @click="$root.showCampaignProposals(campaign.id)">
                                My Proposal
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <button
                            v-if="!proposals.length"
                            class="button"
                            @click="$root.showCampaignApplication(campaign)"
                        >
                            <span>{{ customizationText('get_started_button_text', 'Get Started', campaign) }}</span>
                        </button>
                        <div v-else>
                            <button class="button mb-5" @click="$root.showCampaignProposals(campaign.id)">
                                My Proposals
                            </button>
                            <button
                                v-if="campaign.is_active"
                                class="button mb-5"
                                @click="$root.showCampaignApplication(campaign)"
                            >
                                Submit Another Proposal
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CampaignCustomizeMixin from '../../../mixins/CampaignCustomizeMixin';
    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'CampaignListRow',

        /**
         * The mixins
         *
         * @type {array}
         */
        mixins: [CampaignCustomizeMixin],

        /**
         * The component properties
         */
        props: {
            /**
             * The campaign
             */
            campaign: {
                type: Object,
                required: true
            }
        },

        /**
         * The computed properties
         */
        computed: {
            /**
             * The proposals for this campaign
             *
             * @returns {array}
             */
            proposals() {
                return this.$root.campaignProposals(this.campaign.id);
            },

            /**
             * The accepted proposals
             *
             * @returns {array}
             */
            accepted_proposals() {
                return this.proposals.filter((proposal) => proposal.accepted_at);
            },

            /**
             * Whether the campaign allows recurring proposals
             *
             * @returns {boolean}
             */
            recurring_proposals() {
                return this.campaign.proposal_interval === 1;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .break-new-line {
        white-space: pre-line;
    }
</style>
